function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component } from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import makeCancelable from "./make-promise-cancelable";

var PromiseResolver =
/*#__PURE__*/
function (_Component) {
  _inherits(PromiseResolver, _Component);

  function PromiseResolver() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PromiseResolver);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PromiseResolver)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      data: {},
      loading: false,
      error: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "promise", undefined);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelPromise", function () {
      if (_this.cancelablePromise && typeof _this.cancelablePromise.cancel === "function") {
        _this.cancelablePromise.cancel();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resolvePromise", function () {
      var _this$props = _this.props,
          promise = _this$props.promise,
          args = _this$props.args;

      _this.setState({
        loading: true
      });

      _this.cancelPromise(); // so you don't set state if another request is in progress


      _this.cancelablePromise = makeCancelable(promise(args));

      _this.cancelablePromise.promise.then(function () {
        var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _this.setState({
          loading: false,
          data: resp
        });
      }).catch(function (error) {
        if (!error.isCanceled) {
          _this.setState({
            loading: false,
            error: error
          });

          _this.props.onCatch(error);
        }
      });
    });

    return _this;
  }

  _createClass(PromiseResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resolvePromise();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelPromise();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!_.isEqual(this.props.args, prevProps.args)) {
        this.resolvePromise();
      }

      if (prevProps.promise && this.props.promise && prevProps.promise.toString() !== this.props.promise.toString()) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("don't change promise on the fly"); // eslint-disable-line
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          data = _this$state.data,
          loading = _this$state.loading,
          error = _this$state.error;
      var obj = {
        data: data,
        loading: loading,
        error: error,
        refresh: this.resolvePromise
      };
      return typeof this.props.render === "function" ? this.props.render(obj) : this.props.children(obj);
    }
  }]);

  return PromiseResolver;
}(Component);

_defineProperty(PromiseResolver, "displayName", "PromiseResolver");

_defineProperty(PromiseResolver, "propTypes", {
  args: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number, PropTypes.bool]),
  render: PropTypes.func,
  promise: PropTypes.func,
  onCatch: PropTypes.func,
  children: PropTypes.func
});

_defineProperty(PromiseResolver, "defaultProps", {
  formatResolveValue: function formatResolveValue(data) {
    return data;
  },
  onCatch: _.noop
});

export default PromiseResolver;